import React from 'react'
import Button from './button'
import {withState} from 'recompose'
import styled from 'styled-components'

const Img = styled.img`
  transition: all .3s ease;
  ${props => props.hover && props.selectable && 'transform: scale(1.1);'}
`

const Image = ({ src, selectable, width, height, containerStyle, style, className, hover, setHover, onSelect }) => (
  <div
    style={{
      position: 'relative',
      display: 'inline-block',
      ...(containerStyle || {}),
    }}
    onMouseOver={() => {
      setHover(true)
    }}
    onMouseOut={() => {
      setHover(false)
    }}
  >
    <Img
      className={className}
      hover={hover}
      selectable={selectable}
      src={src}
      style={{
        ...(width && {width}),
        ...(height && {height}),
        ...(style && style),
      }}
    />
    <Button
      hidden={!hover || !selectable}
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1
      }}
      onClick={onSelect}
    >
      Выбрать
    </Button>
  </div>
)

export default withState('hover', 'setHover', false)(Image)


// WEBPACK FOOTER //
// ./src/basic/image.js